import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, RouteObject, useLocation, useRoutes } from "react-router-dom";
import Page404 from "../components/404Page";
import PageLayout from "../layouts/PageLayout";
import DashboardPage from "../pages/dashboard";
import AddFeedbackPage from "../pages/feedback/add";
import { LocalStorageKey } from "../constants/localStorageKeys";
import CartPage from "../pages/newbase/cart";
import ExploreArchivePage from "../pages/newbase/explorearchive";
import ExploreTaskingPage from "../pages/newbase/exploretasking";
import HomePage from "../pages/newbase/home";
import ArchiveOrderListPage from "../pages/newbase/order/archive";
import OrderListPage from "../pages/newbase/order/tasking";
import OrderTaskingDetail from "../pages/newbase/order/tasking/detailOrder";
import EditOrderTasking from "../pages/newbase/order/tasking/editOrder";
import RoleAccessControlProviderUser from "../providers/RoleAccessControlProviderUser";
import { setCurrentURLPath } from "../store/reducers/appCommonSlice";
import CreateArchiveOrder from "../pages/newbase/order/archive/create";

export const baseRoutes = {
  exploreArchive: { path: "/explore-archive" },
  exploreTasking: {
    path: "/explore-tasking",
  },
  order: {
    path: "/order",
    children: {
      managementOrder: { path: "/order/management-order" },
      tasking: { path: "/order/management-tasking" },
    },
  },

  feedback: {
    children: {
      getList: {
        path: "/feedbacks",
      },
    },
  },

  dashboard: "/dashboard",
};
const staticConfig = localStorage.getItem(LocalStorageKey.STATIC_CONFIG);
// @ts-ignore
const parsedConfig = JSON.parse(staticConfig) ?? (await fetch("/config.json"));
const authMethod = parsedConfig.REACT_APP_AUTHENTICATION_METHOD;

const publicRoutes: RouteObject[] = [

];

const childrenCBDRoutes: RouteObject[] = [
  {
    path: baseRoutes.dashboard,
    element: (
      <RoleAccessControlProviderUser>
        <DashboardPage />
      </RoleAccessControlProviderUser>
    ),
  },

  {
    path: `${baseRoutes.feedback.children.getList.path}/create`,
    element: (
      <RoleAccessControlProviderUser>
        <AddFeedbackPage />
      </RoleAccessControlProviderUser>
    ),
  },
];

const protectedRoutes: RouteObject[] = [
  {
    path: "/",
    element: (
      <PageLayout>
        <Outlet />
      </PageLayout>
    ),
    children: [
      {
        path: "/",
        element: <ExploreTaskingPage />,
      },
      {
        path: baseRoutes.exploreArchive.path,
        element: (
          <RoleAccessControlProviderUser>
            <ExploreArchivePage />


          </RoleAccessControlProviderUser>
        ),
      },

      {
        path: "/home",
        element: (
          <RoleAccessControlProviderUser>
            <HomePage />
          </RoleAccessControlProviderUser>
        ),
      },

      {
        path: baseRoutes.exploreTasking.path,
        element: (
          <RoleAccessControlProviderUser>
            <ExploreTaskingPage />
          </RoleAccessControlProviderUser>
        ),
      },
      {
        path: baseRoutes.order.children.tasking.path,
        element: <OrderListPage />,
      },
      {
        path: `${baseRoutes.order.children.tasking.path}/:id`,
        element: <OrderTaskingDetail />,
      },

      {
        path: `${baseRoutes.order.children.tasking.path}/:id/edit`,
        element: <EditOrderTasking />,
      },

      {
        path: "cart",
        element: <CartPage />,
      },

      {
        path: "create-order-archive",
        element: <CreateArchiveOrder />,
      },

      {
        path: baseRoutes.order.children.managementOrder.path,
        element: <ArchiveOrderListPage />,
      },
      { path: "*", element: <Page404 /> },

      ...(authMethod === "OAUTH2" ? childrenCBDRoutes : []),
    ],
  },
];

export const routes: RouteObject[] = [...publicRoutes, ...protectedRoutes];

export default function RouterPage()
{
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() =>
  {
    dispatch(setCurrentURLPath(location.pathname));
  }, [location.pathname]);

  return useRoutes(routes);
}
